/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Recipients_No_RecipientsInputs */



/**
* | output |
* | --- |
* | "No Recipient(s) Assigned" |
*
* @param {Event_Recipients_No_RecipientsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_recipients_no_recipients = /** @type {((inputs?: Event_Recipients_No_RecipientsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Recipients_No_RecipientsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun destinataire assigne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein(e) Empfänger zugewiesen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun destinatario assegnato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получатель(и) не назначен(ы)")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay destinatario(s) asignado(s)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未指定收件人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("受信者が割り当てられていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्राप्तकर्ता निर्धारित नहीं किया गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum destinatário atribuído")
	return /** @type {LocalizedString} */ ("No Recipient(s) Assigned")
});